var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProperty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.17433 5.8207V2.77805C4.17433 2.26663 4.58979 1.85216 5.10207 1.85216C5.61434 1.85216 6.02955 2.26666 6.02955 2.77805V4.05697L10.0279 0.255402C10.3861 -0.085134 10.949 -0.085134 11.3073 0.255402L21.0472 9.51559C21.4182 9.86833 21.4324 10.4544 21.0793 10.8248C20.7259 11.1951 20.1388 11.2095 19.7676 10.8567L19.4798 10.5831V21.2981C19.4798 21.8095 19.0646 22.224 18.5523 22.224H2.78274C2.27044 22.224 1.85525 21.8095 1.85525 21.2981V10.5831L1.56744 10.8567C1.19624 11.2095 0.609096 11.1951 0.255781 10.8248C-0.0973202 10.4544 -0.0831414 9.8683 0.287815 9.51559L4.17433 5.8207ZM3.71071 8.81911V20.3722H17.6248V8.81911L10.6681 2.20487L3.71071 8.81911Z",
    fill: "#001EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty);
export default __webpack_public_path__ + "static/media/Property.fcc7198cdf9158858e08bb0d5a635e29.svg";
export { ForwardRef as ReactComponent };